import { createActionGroup, emptyProps, props } from '@ngrx/store';
import { UserProfile } from '../models/role.model';
import { ProfilePatch } from '../apis/profile.api';

export const ProfileActions = createActionGroup({
  source: 'Profile',
  events: {
    'Load Profile Requested': props<{ uid: string }>(),
    'Load Profile Succeeded': props<{ profile: UserProfile }>(),
    'Load Profile Failed': props<{ error: string }>(),

    'Update Profile Requested': props<{ uid: string; patch: ProfilePatch }>(),
    'Update Profile Succeeded': props<{ patch: ProfilePatch }>(),
    'Update Profile Failed': props<{ error: string }>(),

    'Clear Profile': emptyProps(),
  },
});
